import HighlightableDataTable from "./HighlightableDataTable";

export default HighlightableDataTable;
